import { PublicClientApplication } from '@azure/msal-browser';

// Config de MSAL para el login con Microsoft (Entra ID).
// Los valores vienen de window (public/config.js), igual que el resto de la config del front.
const msalConfig = {
  auth: {
    clientId: window.REACT_APP_MSAL_CLIENT_ID,
    authority: window.REACT_APP_MSAL_AUTHORITY,
    redirectUri: window.REACT_APP_MSAL_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    // Guarda el estado temporal del login (state/nonce/code_verifier) en una cookie de
    // PRIMERA parte (nuestro dominio), no solo en storage. Necesario en navegadores que
    // bloquean/particionan cookies de terceros — sobre todo Chrome (Privacy Sandbox): sin
    // esto, el estado de login.microsoftonline.com se pierde entre logins y el "Iniciar
    // sesión con Microsoft" falla solo en Chrome (Edge/Safari lo manejan distinto).
    storeAuthStateInCookie: true,
  },
};

// Scopes mínimos para obtener el ID token con el email del usuario.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Instancia perezosa: se crea/inicializa recién al primer uso (evita costo al cargar la app
// y que un clientId placeholder rompa el arranque). initialize() es idempotente.
let _instance = null;
let _initialized = false;

export async function getMsalInstance() {
  if (!_instance) {
    _instance = new PublicClientApplication(msalConfig);
  }
  if (!_initialized) {
    await _instance.initialize();
    _initialized = true;
  }
  return _instance;
}
